import React from "react"
import Select from "../../../../atoms/Select"

import DateFilters from "../../pages/ReleaseDetails/components/dateFilter"

import styles from "./index.module.scss"

export const FilterDashboard = ({
  label,
  handleChange,
  listEquipment,
  onSelect,
  nameFilter,
  defaultValue,
}) => {
  const [bCustom, setBcustom] = React.useState(false)

  const options = [
    { label: "Todos", value: null },
    ...listEquipment.map((it) => ({
      label: it.equipment_cname,
      value: it.equipment_nid,
    })),
  ]
  return (
    <div
      className={styles.wrapperFilterDashboard}
      style={{
        justifyContent: bCustom ? "space-between" : "flex-start",
      }}
    >
      <Select
        defaultValue={defaultValue}
        label="Equipamento"
        options={options}
        onSelect={(e) => {
          if (e === null) {
            onSelect(null)
          } else if (e?.length === 0) {
            onSelect(null)
          } else {
            onSelect(e)
          }
        }}
        className={styles.select}
      />

      <DateFilters
        justify="flex-start"
        setBcustom={setBcustom}
        label={label}
        handleChange={handleChange}
        nameFilter={nameFilter}
        selectedDefaultFilter="last_7_days"
      />
    </div>
  )
}
